import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-cream py-16 md:py-24 px-4 overflow-hidden" data-id="element-61">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-62">
        <div className="space-y-8 z-10" data-id="element-63">
          <div className="inline-block border-b border-sage pb-1 mb-2" data-id="element-64">
            <span className="text-sm font-sans font-semibold tracking-widest text-dark-green uppercase" data-id="element-65">
              Reseteo de Emergencia
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-near-black" data-id="element-66">
            El Protocolo Anti-Inflamatorio de 72 Horas
          </h1>
          <p className="text-lg md:text-xl text-gray-700 font-sans leading-relaxed max-w-xl" data-id="element-67">
            Elimina la hinchazón abdominal y recupera tu ligereza en 3 días sin
            pasar hambre ni gastar en suplementos caros.
          </p>
          <div className="pt-4" data-id="element-68">
            <Button onClick={scrollToOffer} className="w-full sm:w-auto group" data-id="element-69">
              Quiero mi protocolo ahora
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-70" />
            </Button>
            <p className="mt-3 text-sm text-gray-500 font-sans" data-id="element-71">
              Acceso inmediato • Pago seguro
            </p>
          </div>
        </div>

        <div className="relative z-0" data-id="element-72">
          <div className="absolute inset-0 bg-sage/20 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-73"></div>
          <img src="https://cdn.magicpatterns.com/uploads/f947N9peBDtYBNqH9MCg4J/heylloyd-image-1773270306530.png" alt="Mockup del Protocolo Anti-Inflamatorio 72H en laptop y tablet" className="w-full h-auto object-cover drop-shadow-2xl rounded-sm" loading="eager" data-id="element-74" />
        </div>
      </div>
    </section>;
}